import { api } from './client';
import { NotificationItem } from '@/domain/types';

export interface NotificationListResponse {
  data: NotificationItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface NotificationListParams {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
}

export const notificationsApi = {
  // List notifications
  list: (params?: NotificationListParams) =>
    api.get<NotificationListResponse>('/notifications', { params }),

  // Mark as read
  markAsRead: (id: string) =>
    api.put(`/notifications/${id}/read`, {}),

  // Mark all as read
  markAllAsRead: () =>
    api.put('/notifications/read-all', {}),
};
